const pushEvent = (analyticsEventInfo) => {
  if (window.digitalData && window.digitalData.event) {
    window.digitalData.event.push(analyticsEventInfo);
  }
};

export const trackClick = (source = 'pip') => {
  pushEvent({
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: `${source} sub-content` },
    subContent: { section: 'sharing', component: 'system', target: 'save', position: 'n/a' }
  });
};

export const trackOverlay = () => {
  pushEvent({
    category: { primaryCategory: 'overlay' },
    eventInfo: { eventName: 'choose a list' }
  });
};

export const trackCreateAList = () => {
  pushEvent({
    category: { primaryCategory: 'overlay' },
    eventInfo: { eventName: 'create a list' }
  });
};

export const trackAddItem = (quantity, price, sku) => {
  pushEvent({
    category: { primaryCategory: 'button submission' },
    eventInfo: { eventName: 'list add' },
    item: [{
      listLocation: window?.digitalData?.page?.pageInfo?.pageType,
      quantity,
      price: { basePrice: price },
      productInfo: { sku }
    }]
  });
};

export const trackAddCollection = (collectionId) => {
  pushEvent({
    category: { primaryCategory: 'button submission' },
    eventInfo: { eventName: 'list add' },
    content: { collection: { collectionID: collectionId } },
    item: [{
      listLocation: 'collections:space',
      quantity: 'n/a',
      price: { basePrice: 'n/a' },
      productInfo: { sku: 'n/a' }
    }]
  });
};